import { elysiumUsers } from "./elysium.js";
import { bexleyLa, bromleyLa, greenwichLa, lambethLa, leadingEdgeIcb, leadingEdgeTrust, leadingEdgeTrustTwo, lewishamLa, slamTrust, southEastLondonIcb, southwarkLa, supersetDashboardOrg, thalamos, } from "./organisations.js";
import { acdFacilitatorIndependentTeam, bexleyAmhpTeam, bexleyPaymentReviewerTeam, bobIndependentTeam, bromleyAmhpTeam, cqcMainTeam, dataControllerCentralTeam, dataControllerNorthTeam, dataControllerSouthTeam, greenwichAmhpTeam, guysAndStThomasMhaTeam, guysHospitalWardTeam, independentDoctorTeam1, independentDoctorTeam2, independentDoctorTeam3, independentDoctorTeam4, independentDoctorTeam5, independentDoctorTeam6, independentDoctorTeam7, independentDoctorTeam8, independentDoctorTeam9, independentDoctorTeam10, independentDoctorTeam11, independentDoctorTeam12, independentDoctorTeam13, independentDoctorTeam14, independentDoctorTeam15, kingsCollegeHospitalMhaTeam, kingsCollegeHospitalWardTeam, lambethAmhpTeam, lambethWardTeam, leadingEdgeAmhpTeam, leadingEdgeMhaTeam, leadingEdgeWardTeam, leadingEdgeWardTeam2, lewishamAmhpTeam, lewishamAndGreenwichMhaTeam, maudsleyWardTeam, oxleasHouseWardTeam, oxleasMhaTeam, soad1IndependentTeam, soad2IndependentTeam, southwarkAmhpTeam, teams, trailingEdgeAmhpTeam, trailingEdgeMhaTeam, trailingEdgeWardTeam, trainingIsabellaSoadTeam, universityHospitalLewishamWardTeam, } from "./teams.js";
export const acdFacilitatorUser = {
    id: "8aff20f1-d261-4b21-8a7a-65b0b36eb4ad",
    name: "Mackenzie ACD Facilitator",
    email: "mackenzie.acd.facilitator@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        { type: "team", teamId: acdFacilitatorIndependentTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const slamMhaUser1 = {
    id: "9fa44843-4eb9-4c24-8254-5a1391a92634",
    name: "Clare MHAAdmin",
    email: "thalamostesting+clare.mhaadmin@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [{ type: "team", teamId: teams.id, role: "member" }],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const slamMhaUser2 = {
    id: "9f626f66-186b-45eb-a3b0-d769e875bf83",
    name: "Simon MHAAdmin",
    email: "thalamostesting+simon.mhaadmin@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        { type: "team", teamId: teams.id, role: "member" },
        {
            type: "team",
            teamId: leadingEdgeMhaTeam.id,
            role: "member",
        },
        {
            type: "team",
            teamId: trailingEdgeMhaTeam.id,
            role: "member",
        },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: true,
    status: "active",
};
export const lewishamMhaUser1 = {
    id: "aaa44843-4eb9-4c24-8254-5a1391a92634",
    name: "Lewisham MHAAdmin",
    email: "lewisham.mhaadmin@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        { type: "team", teamId: lewishamAndGreenwichMhaTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const oxleasMhaUser1 = {
    id: "bba44843-4eb9-4c24-8254-5a1391a92634",
    name: "Oxleas MHAAdmin",
    email: "oxleas.mhaadmin@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [{ type: "team", teamId: oxleasMhaTeam.id, role: "member" }],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const kingsMhaUser1 = {
    id: "cca44843-4eb9-4c24-8254-5a1391a92634",
    name: "King's MHAAdmin",
    email: "kings.mhaadmin@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        { type: "team", teamId: kingsCollegeHospitalMhaTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const guysMhaUser1 = {
    id: "dda44843-4eb9-4c24-8254-5a1391a92634",
    name: "Guy's MHAAdmin",
    email: "guys.mhaadmin@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        { type: "team", teamId: guysAndStThomasMhaTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const bromleyAmhp1 = {
    id: "02c0c69c-f152-4cea-8584-75501143d7d4",
    name: "Peter AMHP",
    email: "thalamostesting+peter.amhp@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        {
            type: "amhp",
            localAuthority: bromleyLa.name,
            localAuthorityOrganisationId: bromleyLa.id,
        },
        { type: "social-worker", registrationNumber: "SW123456" },
    ],
    memberships: [{ type: "team", teamId: bromleyAmhpTeam.id, role: "member" }],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const greenwichAmhp1 = {
    id: "ddc0c69c-f152-4cea-8584-75501143d7d4",
    name: "Greenwich AMHP",
    email: "greenwich.amhp@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        {
            type: "amhp",
            localAuthority: greenwichLa.name,
            localAuthorityOrganisationId: greenwichLa.id,
        },
        { type: "social-worker", registrationNumber: "SW123411" },
    ],
    memberships: [{ type: "team", teamId: greenwichAmhpTeam.id, role: "member" }],
    authenticationMethods: [],
    isOnboarded: true,
    status: "active",
    hasPidAccess: false,
    hasPatientMergeAccess: false,
};
export const southwarkAmhp1 = {
    id: "aac0c69c-f152-4cea-8584-75501143d7d4",
    name: "Southwark AMHP",
    email: "southwark.amhp@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        {
            type: "amhp",
            localAuthority: southwarkLa.name,
            localAuthorityOrganisationId: southwarkLa.id,
        },
        { type: "social-worker", registrationNumber: "SW123411" },
    ],
    memberships: [{ type: "team", teamId: southwarkAmhpTeam.id, role: "member" }],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const lewishamAmhp1 = {
    id: "bbc0c69c-f152-4cea-8584-75501143d7d4",
    name: "Lewisham AMHP",
    email: "lewisham.amhp@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        {
            type: "amhp",
            localAuthority: lewishamLa.name,
            localAuthorityOrganisationId: lewishamLa.id,
        },
        { type: "social-worker", registrationNumber: "SW123422" },
    ],
    memberships: [{ type: "team", teamId: lewishamAmhpTeam.id, role: "member" }],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const lambethAmhp1 = {
    id: "ccc0c69c-f152-4cea-8584-75501143d7d4",
    name: "Lambeth AMHP",
    email: "lambeth.amhp@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        {
            type: "amhp",
            localAuthority: lambethLa.name,
            localAuthorityOrganisationId: lambethLa.id,
        },
        { type: "social-worker", registrationNumber: "SW123422" },
    ],
    memberships: [{ type: "team", teamId: lambethAmhpTeam.id, role: "member" }],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const bexleyAmhp1 = {
    id: "a8ce5140-0a1b-4596-8380-b62a6e7f453a",
    name: "Kara AMHP",
    email: "thalamostesting+kara.amhp@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        {
            type: "amhp",
            localAuthority: bexleyLa.name,
            localAuthorityOrganisationId: bexleyLa.id,
        },
        { type: "social-worker", registrationNumber: "SW654321" },
    ],
    memberships: [
        { type: "team", teamId: bromleyAmhpTeam.id, role: "member" },
        { type: "team", teamId: leadingEdgeAmhpTeam.id, role: "member" },
        { type: "team", teamId: trailingEdgeAmhpTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const bexleyAmhp2 = {
    id: "268b1862-bab7-43ae-92a5-e0ac20d84018",
    name: "Andy AMHP",
    email: "thalamostesting+andy.amhp@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        {
            type: "amhp",
            localAuthority: bexleyLa.name,
            localAuthorityOrganisationId: bexleyLa.id,
        },
        { type: "social-worker", registrationNumber: "SW654324" },
    ],
    memberships: [
        { type: "team", teamId: bexleyAmhpTeam.id, role: "member" },
        { type: "team", teamId: leadingEdgeAmhpTeam.id, role: "member" },
        { type: "team", teamId: trailingEdgeAmhpTeam.id, role: "member" },
        { type: "team", teamId: bexleyPaymentReviewerTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const lambethWardTeamUser = {
    id: "d312166b-ac2d-4981-8004-b4bc080aea5f",
    name: "Ross Nurse",
    email: "thalamostesting+ross.nurse@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [{ type: "nurse", pinNumber: "A123DDF" }],
    memberships: [
        { type: "team", teamId: lambethWardTeam.id, role: "member" },
        { type: "team", teamId: leadingEdgeWardTeam.id, role: "member" },
        { type: "team", teamId: trailingEdgeWardTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const knitSoadWardTeamUser = {
    id: "a92c2dbc-e194-4a26-b8be-7bf305eb6f71",
    name: "Knit Soad",
    email: "thalamostesting+knit.soad@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        { type: "team", teamId: soad1IndependentTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: true,
    hasPatientMergeAccess: true,
    status: "active",
};
export const purlSoadWardTeamUser = {
    id: "34b0a28f-31c6-46bb-9a74-2931482a886c",
    name: "Purl Soad",
    email: "thalamostesting+purl.soad@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        { type: "team", teamId: soad2IndependentTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: true,
    hasPatientMergeAccess: true,
    status: "active",
};
export const trainingIsabellaSoadUser = {
    id: "4cf838c3-5192-45e1-9b7e-87418d2d0bc1",
    name: "Training Isabella Soad",
    email: "thalamostesting+isabellasoad@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        { type: "team", teamId: trainingIsabellaSoadTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: true,
    hasPatientMergeAccess: true,
    status: "active",
};
export const cqcAdminTeamUser = {
    id: "a4b0a28f-31c6-46bb-9a74-2931482a886c",
    name: "CQC Admin 1",
    email: "thalamostesting+cqc.admin.1@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [{ type: "team", teamId: cqcMainTeam.id, role: "member" }],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: true,
    hasPatientMergeAccess: true,
    status: "active",
};
export const regularDoctorWardTeamUser = {
    id: "a8b1ee54-284a-48ff-8163-add6073354cd",
    name: "Bob Regular Doctor",
    email: "thalamostesting+bob.regular.doctor@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [{ type: "doctor", gmcNumber: "A123DDF" }],
    memberships: [
        { type: "team", teamId: bobIndependentTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const multipleWardTeamsUser = {
    id: "2d78f58a-c118-4d54-b805-0ab94ab3beb0",
    name: "Mary AC",
    email: "thalamostesting+mary.ac@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        { type: "approved-clinician", expiryDate: "2030-01-01" },
        { type: "section-12", expiryDate: "2030-01-01" },
        { type: "doctor", gmcNumber: "1234567" },
    ],
    memberships: [
        { type: "team", teamId: maudsleyWardTeam.id, role: "manager" },
        { type: "team", teamId: lambethWardTeam.id, role: "member" },
        { type: "team", teamId: maudsleyWardTeam.id, role: "member" },
        { type: "team", teamId: leadingEdgeWardTeam.id, role: "member" },
        { type: "team", teamId: trailingEdgeWardTeam.id, role: "member" },
        {
            type: "organisation",
            organisationId: supersetDashboardOrg.id,
            role: "member",
        },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const leadingEdgeAcDoctor = {
    id: "3496afa1-f579-443c-8ddc-af3bceccc218",
    name: "Laura AC",
    email: "thalamostesting+laura.ac@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        { type: "approved-clinician", expiryDate: "2030-01-01" },
        { type: "section-12", expiryDate: "2030-01-01" },
        { type: "doctor", gmcNumber: "7654321" },
    ],
    memberships: [
        { type: "team", teamId: leadingEdgeWardTeam.id, role: "member" },
        { type: "team", teamId: leadingEdgeWardTeam2.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
// Nurse prescriber who is also an Approved Clinician, in the (s62-enabled)
// Leading Edge org. Used to e2e the nurse-AC start arm of the S62 rule.
export const leadingEdgeNurseApprovedClinician = {
    id: "d63a9fd2-fff0-4fbf-b1a7-6afa542f9fbf",
    name: "Nina Nurse-AC",
    email: "thalamostesting+nina.nurse.ac@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        { type: "nurse", pinNumber: "NA123456" },
        { type: "approved-clinician", expiryDate: "2030-01-01" },
    ],
    memberships: [
        { type: "team", teamId: leadingEdgeWardTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
// HCPC-registered professional (no AC) in the (s62-enabled) Leading Edge org.
// Used to e2e the HCPC view/invite arm of the S62 rule.
export const leadingEdgeHcpcUser = {
    id: "ae4f9670-37e4-4588-a439-9f051186c6a6",
    name: "Holly HCPC",
    email: "thalamostesting+holly.hcpc@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [{ type: "hcpc", registrationNumber: "AB123456" }],
    memberships: [
        { type: "team", teamId: leadingEdgeWardTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const oxleasWardTeamsUser = {
    id: "aa78f58a-c118-4d54-b805-0ab94ab3beb0",
    name: "Oxleas AC",
    email: "oxleas.ac@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        { type: "approved-clinician", expiryDate: "2023-01-01" },
        { type: "section-12", expiryDate: "2023-01-01" },
        { type: "doctor", gmcNumber: "1234567" },
    ],
    memberships: [
        { type: "team", teamId: oxleasHouseWardTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const kingsWardTeamsUser = {
    id: "bb78f58a-c118-4d54-b805-0ab94ab3beb0",
    name: "King's AC",
    email: "kings.ac@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        { type: "approved-clinician", expiryDate: "2023-01-01" },
        { type: "section-12", expiryDate: "2023-01-01" },
        { type: "doctor", gmcNumber: "1234567" },
    ],
    memberships: [
        { type: "team", teamId: kingsCollegeHospitalWardTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const lewishamWardTeamsUser = {
    id: "cc78f58a-c118-4d54-b805-0ab94ab3beb0",
    name: "Lewisham AC",
    email: "lewisham.ac@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        { type: "approved-clinician", expiryDate: "2023-01-01" },
        { type: "section-12", expiryDate: "2023-01-01" },
        { type: "doctor", gmcNumber: "1234567" },
    ],
    memberships: [
        {
            type: "team",
            teamId: universityHospitalLewishamWardTeam.id,
            role: "member",
        },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const guysWardTeamsUser = {
    id: "cc78f58a-c118-4d54-b805-0ab94ab3beb0",
    name: "Guys AC",
    email: "guys.ac@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [
        { type: "approved-clinician", expiryDate: "2023-01-01" },
        { type: "section-12", expiryDate: "2023-01-01" },
        { type: "doctor", gmcNumber: "1234567" },
    ],
    memberships: [
        { type: "team", teamId: guysHospitalWardTeam.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const demographicsManager = {
    id: "abb553ed-ccdf-4f5c-8281-f8cdff365548",
    name: "David Demographics",
    email: "thalamostesting+david.demographics@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        {
            type: "organisation",
            organisationId: southEastLondonIcb.id,
            role: "demographics-manager",
        },
        {
            type: "organisation",
            organisationId: leadingEdgeIcb.id,
            role: "demographics-manager",
        },
        {
            type: "organisation",
            organisationId: leadingEdgeTrust.id,
            role: "demographics-manager",
        },
        {
            type: "organisation",
            organisationId: leadingEdgeTrustTwo.id,
            role: "demographics-manager",
        },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const icsAnalyticsUser = {
    id: "a77553ed-ccdf-4f5c-8281-f8cdff365548",
    name: "Ross Analytics",
    email: "ross.ics.analytics@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        {
            type: "organisation",
            organisationId: southEastLondonIcb.id,
            role: "member",
        },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const icsOrganisationAdmin = {
    id: "bf7aabde-bfd5-4d12-aa79-2aefa2e9e813",
    name: "Bryan ICS Admin",
    email: "bryan.ics.admin@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        {
            type: "organisation",
            organisationId: southEastLondonIcb.id,
            role: "manager",
        },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const slamTrustOrganisationAdmin = {
    id: "ef7aabde-bfd5-4d12-aa79-21efa2e9e823",
    name: "Bettie SLAM Trust Admin",
    email: "bettie.trust.admin@aspire.thalamos.co.uk",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        {
            type: "organisation",
            organisationId: slamTrust.id,
            role: "manager",
        },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const thalamosAdmin = {
    id: "def8792f-0df8-43ad-a6f7-e05f1a305f94",
    name: "Thalamos Admin",
    email: "thalamostesting+testingadmin@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        {
            type: "organisation",
            organisationId: thalamos.id,
            role: "member",
        },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const dataSharingPartnershipMember = {
    id: "16fe475f-d05f-4927-aa81-70e9c740894d",
    name: "Data Sharing Partnership Member",
    email: "thalamostesting+dsp.member@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    accreditations: [],
    memberships: [
        {
            type: "team",
            teamId: dataControllerNorthTeam.id,
            role: "member",
        },
        {
            type: "team",
            teamId: dataControllerCentralTeam.id,
            role: "member",
        },
        {
            type: "team",
            teamId: dataControllerSouthTeam.id,
            role: "member",
        },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: true,
    status: "active",
};
// Additional Independent Doctors for S12
export const independentDoctor1 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb00",
    name: "Dr. Amara Okafor",
    email: "thalamostesting+s12independentdoctor1@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "45 Bexley Road, Erith", postalCode: "DA8 1LB" },
    accreditations: [
        { type: "doctor", gmcNumber: "7123456" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam1.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor2 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb01",
    name: "Dr. James Chen",
    email: "thalamostesting+s12independentdoctor2@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: {
        address: "12 Greenwich High Road",
        postalCode: "SE10 8JL",
    },
    accreditations: [
        { type: "doctor", gmcNumber: "7234567" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam2.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor3 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb02",
    name: "Dr. Sarah Williams",
    email: "thalamostesting+s12independentdoctor3@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: {
        address: "78 Woolwich Road, Charlton",
        postalCode: "SE18 6QF",
    },
    accreditations: [
        { type: "doctor", gmcNumber: "7345678" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam3.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor4 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb03",
    name: "Dr. Rajesh Patel",
    email: "thalamostesting+s12independentdoctor4@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "3 Bromley Common", postalCode: "BR2 9RH" },
    accreditations: [
        { type: "doctor", gmcNumber: "7456789" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam4.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor5 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb04",
    name: "Dr. Fatima Al-Rashid",
    email: "thalamostesting+s12independentdoctor5@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "22 Beckenham Road", postalCode: "BR3 4PF" },
    accreditations: [
        { type: "doctor", gmcNumber: "7567890" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam5.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor6 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb05",
    name: "Dr. Michael O'Brien",
    email: "thalamostesting+s12independentdoctor6@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "15 Camberwell Road", postalCode: "SE5 0EZ" },
    accreditations: [
        { type: "doctor", gmcNumber: "7678901" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam6.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor7 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb06",
    name: "Dr. Priya Sharma",
    email: "thalamostesting+s12independentdoctor7@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "9 Borough High Street", postalCode: "SE1 1NP" },
    accreditations: [
        { type: "doctor", gmcNumber: "7789012" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam7.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor8 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb07",
    name: "Dr. David Thompson",
    email: "thalamostesting+s12independentdoctor8@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "88 Brixton Road", postalCode: "SW9 6BE" },
    accreditations: [
        { type: "doctor", gmcNumber: "7890123" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam8.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor9 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb08",
    name: "Dr. Aisha Mohammed",
    email: "thalamostesting+s12independentdoctor9@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: {
        address: "31 Lewisham High Street",
        postalCode: "SE13 5AF",
    },
    accreditations: [
        { type: "doctor", gmcNumber: "7901234" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam9.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor10 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb09",
    name: "Dr. Thomas Anderson",
    email: "thalamostesting+s12independentdoctor10@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "5 Russell Square", postalCode: "WC1B 5EH" },
    accreditations: [
        { type: "doctor", gmcNumber: "7012345" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam10.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor11 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb0a",
    name: "Dr. Yuki Tanaka",
    email: "thalamostesting+s12independentdoctor11@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "17 Clerkenwell Green", postalCode: "EC1R 0DP" },
    accreditations: [
        { type: "doctor", gmcNumber: "7112345" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam11.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor12 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb0b",
    name: "Dr. Elena Rodriguez",
    email: "thalamostesting+s12independentdoctor12@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "60 Harley Street", postalCode: "W1G 7HA" },
    accreditations: [
        { type: "doctor", gmcNumber: "7212346" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam12.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor13 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb0c",
    name: "Dr. Kwame Mensah",
    email: "thalamostesting+s12independentdoctor13@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: {
        address: "14 George Street, Croydon",
        postalCode: "CR0 1LA",
    },
    accreditations: [
        { type: "doctor", gmcNumber: "7312347" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam13.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor14 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb0d",
    name: "Dr. Sophie Dubois",
    email: "thalamostesting+s12independentdoctor14@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: { address: "7 Streatham High Road", postalCode: "SW16 1DS" },
    accreditations: [
        { type: "doctor", gmcNumber: "7412348" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam14.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const independentDoctor15 = {
    id: "ff9d922e-7c68-4f43-ac6f-de7c8aadeb0e",
    name: "Dr. Ahmed Hassan",
    email: "thalamostesting+s12independentdoctor15@gmail.com",
    address: { address: "123 User Street", postalCode: "SE4 2BQ" },
    homeBaseAddress: {
        address: "29 Norwood Road, Herne Hill",
        postalCode: "SE24 9AA",
    },
    accreditations: [
        { type: "doctor", gmcNumber: "7512349" },
        { type: "section-12", expiryDate: "2027-01-18" },
    ],
    memberships: [
        { type: "team", teamId: independentDoctorTeam15.id, role: "member" },
    ],
    authenticationMethods: [],
    isOnboarded: true,
    hasPidAccess: false,
    hasPatientMergeAccess: false,
    status: "active",
};
export const defaultUsers = [
    slamMhaUser1,
    slamMhaUser2,
    bromleyAmhp1,
    bexleyAmhp1,
    bexleyAmhp2,
    lambethWardTeamUser,
    multipleWardTeamsUser,
    leadingEdgeAcDoctor,
    leadingEdgeNurseApprovedClinician,
    leadingEdgeHcpcUser,
    regularDoctorWardTeamUser,
    icsAnalyticsUser,
    acdFacilitatorUser,
    greenwichAmhp1,
    lambethAmhp1,
    southwarkAmhp1,
    lewishamAmhp1,
    lewishamWardTeamsUser,
    guysWardTeamsUser,
    oxleasWardTeamsUser,
    kingsWardTeamsUser,
    guysMhaUser1,
    lewishamMhaUser1,
    oxleasMhaUser1,
    kingsMhaUser1,
    // Admins
    slamTrustOrganisationAdmin,
    icsOrganisationAdmin,
    thalamosAdmin,
    // Data Sharing Partnerships
    dataSharingPartnershipMember,
    demographicsManager,
    knitSoadWardTeamUser,
    purlSoadWardTeamUser,
    trainingIsabellaSoadUser,
    cqcAdminTeamUser,
    // Independent Doctors for S12
    independentDoctor1,
    independentDoctor2,
    independentDoctor3,
    independentDoctor4,
    independentDoctor5,
    independentDoctor6,
    independentDoctor7,
    independentDoctor8,
    independentDoctor9,
    independentDoctor10,
    independentDoctor11,
    independentDoctor12,
    independentDoctor13,
    independentDoctor14,
    independentDoctor15,
    ...elysiumUsers,
];
//# sourceMappingURL=users.js.map